import { useState } from "react"
import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerLanguageSwitch = props => {
  const [currentLanguage, setCurrentLanguage] = useState(null)
  const [newLanguage, setNewLanguage] = useState(null)

  const datalayerLanguageSwitchHandler = event => {
    const validClasses = [
      "luna-language-selector, .luna-language-selector__body-section-item",
      "luna-language-selector__body-section-item-text",
      "t2-language-selector, .t2-language-selector__body-section-item",
      "t2-language-selector__body-section-item-text",
    ]

    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      setCurrentLanguage(
        document.querySelector(".luna-language-selector__header-text-language")
          ?.innerText !== null ? document.querySelector(".luna-language-selector__header-text-language")
          ?.innerText : document.querySelector(".t2-language-selector__header-text-language")
          ?.innerText
      )
      setNewLanguage(
        document.querySelector(".luna-language-selector__body-section-item-icon > img")?.parentElement?.nextSibling?.innerText !== null 
        ? document.querySelector(".luna-language-selector__body-section-item-icon > img")?.parentElement?.nextSibling?.innerText 
        : document.querySelector(".t2-language-selector__body-section-item-icon > img")?.parentElement?.nextSibling?.innerText
      )
    }
    if (
      event.target.classList.contains(
        "luna-language-selector__body-footer-button"
      ) || 
      event.target.classList.contains(
        "t2-language-selector__body-footer-button"
      )
    ) {
      let languageItem = document.getElementsByClassName(
        "luna-language-selector__header-text-language"
      ) || document.getElementsByClassName(
        "t2-language-selector__header-text-language"
      )
      let previousLanguage = null
      if (languageItem?.[0]?.textContent) {
        previousLanguage =
          languageItem[0].textContent || languageItem[0].innerText
      }
      window.dataLayer.push({
        event: "language_click",
        previous_language_name: currentLanguage,
        new_language_name: newLanguage,
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query =
      document?.querySelectorAll(
        ".luna-language-selector, .luna-language-selector__body-section-item, .luna-language-selector__body-section-item-text, .t2-language-selector, .t2-language-selector__body-section-item, .t2-language-selector__body-section-item-text"
      ).length > 0
  }
  useClickListener(datalayerLanguageSwitchHandler, query)
}

export default DatalayerLanguageSwitch
